import React           from 'react';
import PropTypes       from 'prop-types';
import Translations    from '../../../utils/Translations';
import Constants       from '../../../flux/Constants';
import VideosBlock     from "../../../components/Video/Block/VideosBlock";
import VideoTrendsGrid from "../../../components/Video/VideoTrendsGrid";
import UrlBuilder      from "../../../utils/UrlBuilder";
import Flux            from "../../../flux/Flux";

class TrendingVideosBlock extends React.Component {
	render() {
		if (!this.props.isGuestLoggedIn) {
			return null;
		}
		return (
			<VideosBlock title={Translations.get('VideoBlockVideoTrendsTitle')}
			             link={UrlBuilder.buildVideosTrendingRoute()}
			             category={Constants.Video.CategoriesV2.TRENDING_VIDEOS}
			             grid={VideoTrendsGrid}
			             countLabel={Translations.get('VideoBlockVideoTrendsItemCountLabel')}
			             tileCount={9}
			             lazyImageLoading={this.props.lazyImageLoading}
						 doGaTracking={true}
						 videoTitleType={"h3"}
			/>
		);
	}
}

TrendingVideosBlock.propTypes = {
	isGuestLoggedIn:  PropTypes.bool,
	lazyImageLoading: PropTypes.bool,
	headlineType:     PropTypes.oneOf(Object.values(Flux.Constants.Headlines)),
};

TrendingVideosBlock.defaultProps = {
	isGuestLoggedIn:  false,
	lazyImageLoading: false,
	headlineType:     Flux.Constants.Headlines.h2,
};

export default TrendingVideosBlock;
